import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import { useProductTypeInput_PimSearchProductTypesQuery } from "./ProductTypeInput.generated.js";

/**
 * The reference-system key of the product type with this id. `productTypeKey`
 * is null while `loading`, when PIM does not return the type, or without an
 * id. For an id that is stored (a concrete product's own type) and has to
 * become a key filter.
 */
export function useProductTypeKey(productTypeId: string | null | undefined): {
  productTypeKey: string | null;
  loading: boolean;
} {
  const client = useApolloClient();
  const query = useProductTypeInput_PimSearchProductTypesQuery({
    client,
    variables: {
      productTypeIds: productTypeId ? [productTypeId] : [],
      productTypeSystem: "REFERENCE",
    },
    skip: !productTypeId,
  });

  return {
    productTypeKey:
      getDataOrNull(query.data?.pimSearchProductTypes)?.productTypes?.[0]
        ?.key ?? null,
    loading: query.loading,
  };
}
